import { useDrop } from "react-dnd";
import { useDrag } from "react-dnd";
import { StateService } from "../services/StateService";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import checkIcon from "../assets/tick-icon1.svg";
import clsx from "clsx";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 50,
    width: 36,
    height: 36,
    backgroundColor: "rgba(255,255,255,0.80)",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#fff",
    border: "1px solid #4E37DE",

    backgroundSize: 16,
    "&:before": {
      display: "block",
      width: 20,
      height: 16,
      backgroundImage: `url(${checkIcon})`,
      backgroundRepeat: "no-repeat",
      content: '""',
      position: "relative",
      top: "10px",
      left: "7px",
    },
    "input:hover ~ &": {
      backgroundColor: "#fff",
    },
  },
  cardImgTitle: {
    color: '#fff',
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Gilroy-Medium, sans-serif',
    marginRight: 'auto',
    lineHeight: 3,
    height: 36,
  },
});

interface DroppableImageBoxProps {
  hasImage: boolean;
  rank: number;
  src?: string;
  thumbnail?: string;
  caption?: string;
  state: StateService;
  openImage: (e: any, src: string) => void;
  active: boolean;
  disabled: boolean;
}

export const DroppableImageBox = ({
  hasImage,
  rank,
  src,
  thumbnail,
  caption,
  state,
  openImage,
  active,
  disabled,
}: DroppableImageBoxProps) => {
  const [{ canDrop }, drop] = useDrop(
    () => ({
      accept: "art-image",
      canDrop: () => true,
      drop: (item: any, monitor) => {

        // If there is already an image at this location, perform a 'swap'
        if (
          hasImage &&
          src &&
          item.src !== undefined &&
          item.src.length > 0
        ) {
          state.images.swapRank(src, item.src);
          return;
        }

        if (item.src !== undefined && item.src.length > 0) {
          state.images.selectImage(item.src, true, rank);
        }
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [hasImage, rank, src]
  );

  const [, drag] = useDrag(
    () => ({
      type: "art-image",
      item: { src: src },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [drop, src]
  );

  const classes = useStyles();

  return (
    <>
      {!hasImage && (
        <div className="col col-md-3">
          <div
            className="cardimgbox card-dragbox"
            ref={drop}
            style={{ borderColor: canDrop ? "#000" : "" }}
          >
            <div className="rankNo">Rank {rank}</div>
            <p>Select your favourite artwork below</p>
          </div>
          <div className={classes.cardImgTitle}></div>
        </div>
      )}
      {hasImage && (
        <div className="col col-md-3">
          <div className="cardimgbox" ref={drop}>
            <a href="/vote" onClick={(e) => openImage(e, src ?? "")}>
              <img className="main-image" src={thumbnail} alt="" ref={drag} />
            </a>
              <div className={classes.cardImgTitle}>{caption}</div>


            {active && !disabled && (<div className="selected">
              <Checkbox
                className={classes.root}
                disableRipple
                color="default"
                checkedIcon={
                  <span className={clsx(classes.icon, classes.checkedIcon)} />
                }
                icon={<span className={classes.icon} />}
                inputProps={{ "aria-label": "decorative checkbox" }}
                checked={true}
                onChange={(e) =>
                  {state.images.selectImage(src ?? "", false, 0);}
                }
              />
            </div>)}
          </div>
        </div>
      )}
    </>
  );
};
